import { Component, Input } from '@angular/core';

@Component({
	selector: 'my-account-order-track-components-manual-adjustment-dialog',
	templateUrl: './manual-adjustment-dialog.component.html',
})
export class ManualAdjustmentDialogComponent {

	@Input()
		amount: number;

}
